import { ButtonGroup } from "@mui/material";

import { isDeviceLocationAvailable } from "../../../helpers/deviceHelpers";
import { Device } from "../Device";
import BurnKeysButton from "./Actions/BurnKeysButton";
import ShowMapButton from "./Actions/ShowMapButton";

const renderActions = (row: Device): JSX.Element => {
  const locationAvailable = isDeviceLocationAvailable(row);

  return (
    <ButtonGroup size="small">
      {locationAvailable ? <ShowMapButton device={row} /> : <></>}
      <BurnKeysButton device={row} />
    </ButtonGroup>
  );
};

export default renderActions;
